<div class="brand-logo">
  <div *ngIf="white; else standard">
    <img src="https://hubdash.s3.eu-west-2.amazonaws.com/brand/logo/hubdash-logo-light.svg">
  </div>
  <ng-template #standard>
    <img src="https://hubdash.s3.eu-west-2.amazonaws.com/brand/logo/hubdash-logo.svg">
  </ng-template>
</div>
